import React, { Component } from 'react';
import injectsheet from 'react-jss';
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Fade from 'react-reveal/Fade';
import {Link} from "react-router-dom";


const styles = {
    banner: {
        position: 'relative',
        // backgroundColor: '#b8c6db',
        // backgroundImage: 'linear-gradient(315deg, #b8c6db 0%, #f5f7fa 74%)',
        '& .slick-prev':{
            left: '25px',
        },
        '& .slick-next':{
            right: '25px'
        },
        '& .slide':{
            position: 'relative',
            padding: '50px',
            minHeight: '500px',
            backgroundSize: 'cover',
            display: 'flex !important',
            justifyContent: 'center',
            flexDirection: 'column',
            '& .title':{
                fontSize: '3.5rem',
                fontWeight: '400',
                lineHeight: '43px',
                textTransform: 'uppercase'
            },
            '& .text-shadow':{
                textShadow: '1px 1px 3px #000'
            },
            '& .text-bold':{
                fontWeight: '800'
            },
            '& .overlay':{
                position: 'absolute',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(to right, rgba(230, 92, 0, 0.5), rgba(255, 255, 255, 0.4));',
                top: 0,
                left: 0,
                zIndex: 0,
            },
            '&#slide1':{
                background: "url('/images/classroom.jpg') no-repeat center",
                backgroundSize: 'cover',
                color: '#f5f5f5',
                '& p':{
                    fontSize: '26px'
                }
            },
            '&#slide2':{
                background: "url('/images/vidyayatan3.jpg') no-repeat center",
                backgroundSize: '100%  100%',
                // color: '#f5f5f5',
                // '& p':{
                //     fontSize: '26px'
                // }
            },
            '&#slide3':{
                background: "url('/images/vidyayatan.jpg') no-repeat center",
                backgroundSize: 'cover',
                '& p':{
                    fontSize: '26px'
                }
            }
        },
        '& .slick-slider .slick-dots':{
            bottom: '90px',
            '& li button:before':{
                fontSize: '12px',
            }
        },
        '& #facilities':{
            position: 'relative',
            bottom: '80px',
            marginBottom: '-80px',
            background: '#fff',
            border: '1px solid #e8e8e8',
            borderTopRightRadius: '4px',
            borderTopLeftRadius: '4px',
            '&:before':{
                top: '-1px',
                left: '-1px',
                right: '-1px',
                height: '4px',
                borderTopLeftRadius: '4px',
                content: '""',
                position: 'absolute',
                backgroundColor: '#007bff',
                borderTopRightRadius: '4px'
            },
            '& .material-icons':{
                color: 'inherit'
            },
            '& .facility':{
                position: 'relative',
                transition: '.3s ease color',
                color: '#004da0',
                '&:hover':{
                    color:'#007bff'
                },
                '&:not(:last-child):after':{
                    position: 'absolute',
                    content: '""',
                    top: '13%',
                    right: 0,
                    height: '75%',
                    width: '1px',
                    backgroundColor: '#e8e8e8',
                },
            }
        },
        '@media (max-width: 575px)': {
            '& #facilities':{
                bottom: 0,
                marginBottom: 0,
            },
            '& .slick-slider .slick-dots':{
                bottom: '25px'
            },
        }
    }
}


class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
        activeSlide: 0,
        activeSlide2: 0
    };
  }

  render() {
      const {classes} = this.props;
      const settings = {
          dots: true,
          infinite: true,
          fade: true,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          // beforeChange: (current, next) => this.setState({ activeSlide: next }),
          afterChange: current => this.setState({ activeSlide: current })
      };

    return (
      <div className={classes.banner}>
          <Slider {...settings}>
              <div id="slide1" className="slide">
                  <div className="overlay"></div>
                  <div className="row" style={{zIndex:'1'}}>
                      {/*<Fade when={(this.state.activeSlide === 0)} mirror delay={500} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 0)} mirror top opposite cascade>
                        <div className="col-md-5">
                              <h1 className="title text-shadow">Vidyayatan</h1>
                              <h4 className="text-shadow">Ranchi Centre</h4>
                        </div>
                      </Fade>
                      {/*<Fade when={(this.state.activeSlide === 0)} mirror delay={1000} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 0)} mirror delay={500} top opposite cascade>
                          <div className="col-md-7 text-left pt-4">
                              <p className="lead text-shadow">Preparation for JRF-NET / GATE / CSIR and Ph.D Entrance exams.<br/>New Batch of CSIR JRF/NET Life Sciences - Feb and March 2022.</p>
                              <span className="lead text-shadow">Call Now: <a className="btn btn-outline-primary text-white" href="tel:+91 7004600534">+91 7004600534</a></span>
                          </div>
                      </Fade>
                  </div>
              </div>
              <div id="slide2" className="slide">
                  <div className="row">
                      {/*<Fade when={(this.state.activeSlide === 1)} mirror delay={500} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 1)} mirror top opposite cascade>
                          <div className="col-md-5">
                              {/*<h1 className="title text-shadow">Online Test</h1>*/}
                              {/*<h4 className="text-shadow">Test, Analyze, Track</h4>*/}
                          </div>
                      </Fade>
                      {/*<Fade when={(this.state.activeSlide === 1)} mirror delay={1000} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 1)} mirror delay={500} top opposite cascade>
                          <div className="col-md-7 text-left pt-4">
                              {/*<p className="lead text-shadow">Test & Analyze your skill online.<br/>Specially curated Question sets based on Current Syllabus.</p>*/}
                              {/*<span className="lead text-shadow"><a className="btn btn-outline-primary text-white" href="https://exam.vidyayatan.in" target="_blank" rel="noopener noreferrer">Logon now</a></span>*/}
                          </div>
                      </Fade>
                  </div>
              </div>
              <div id="slide3" className="slide">
                  <div className="row">
                      {/*<Fade when={(this.state.activeSlide === 1)} mirror delay={500} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 2)} mirror top opposite cascade>
                          <div className="col-md-5">
                              {/*<h1 className="title text-shadow">Online Classes</h1>*/}
                              {/*<h4 className="text-shadow">Join live classes using Zoom</h4>*/}
                          </div>
                      </Fade>
                      {/*<Fade when={(this.state.activeSlide === 1)} mirror delay={1000} top opposite cascade>*/}
                      <Fade when={(this.state.activeSlide === 2)} mirror delay={500} top opposite cascade>
                          <div className="col-md-7 text-left pt-4">
                              {/*<p className="lead text-shadow">Registration for fresh batch is on.<br/>For details please contact. <a className="btn btn-outline-primary text-white" href="tel:+91 7004600534">+91 7004600534</a></p>*/}
                          </div>
                      </Fade>
                  </div>
              </div>
              {/*<div id="slide3" className="slide">*/}
              {/*    <div className="row">*/}
              {/*        /!*<Fade when={(this.state.activeSlide === 1)} mirror delay={500} top opposite cascade>*!/*/}
              {/*        <Fade when={(this.state.activeSlide === 2)} mirror top opposite cascade>*/}
              {/*            <div className="col-md-5">*/}
              {/*                <h1 className="title text-shadow">Mobile Application</h1>*/}
              {/*                <h4 className="text-shadow">Test, Analyze, Track from Mobile</h4>*/}
              {/*            </div>*/}
              {/*        </Fade>*/}
              {/*        /!*<Fade when={(this.state.activeSlide === 1)} mirror delay={1000} top opposite cascade>*!/*/}
              {/*        <Fade when={(this.state.activeSlide === 2)} mirror delay={500} top opposite cascade>*/}
              {/*            <div className="col-md-7 text-left pt-4">*/}
              {/*                <p className="lead text-shadow">Test & Analyze your skill online.<br/>Specially curated Question sets based on Current Syllabus.</p>*/}
              {/*                <span className="lead text-shadow"><a className="btn btn-outline-primary text-white" href="https://play.google.com/store/apps/details?id=com.roguepixxel.vidyayatan" target="_blank" rel="noopener noreferrer">Download Now</a></span>*/}
              {/*            </div>*/}
              {/*        </Fade>*/}
              {/*    </div>*/}
              {/*</div>*/}
          </Slider>
          <Fade cascade bottom big>
              <div className="container w-100 d-flex flex-wrap" id="facilities">
                  <Link to={"/courses"} className="flex-fill p-3 facility" >
                      <i className="material-icons md-48">list_alt</i>
                      <p>ClassRoom Programs</p>
                  </Link>
                  <div className="flex-fill p-3 facility">
                      <i className="material-icons md-48">library_books</i>
                      <p>Study Materials</p>
                  </div>
                  <div className="flex-fill p-3 facility">
                      <i className="material-icons md-48">assessment</i>
                      <p>Regular Evaluation</p>
                  </div>
                  <a href="https://exam.vidyayatan.in" target="_blank" rel="noopener noreferrer" className="flex-fill p-3 facility">
                      <i className="material-icons md-48">edit</i>
                      <p>Test Series</p>
                  </a>
                  <div className="flex-fill p-3 facility">
                      <i className="material-icons md-48">meeting_room</i>
                      <p>Hostel Facility</p>
                  </div>
                  <a href="https://exam.vidyayatan.in" target="_blank" rel="noopener noreferrer" className="flex-fill p-3 facility">
                      <i className="material-icons md-48">computer</i>
                      <p>Online Portal</p>
                  </a>
              </div>
          </Fade>
      </div>
    );
  }
}

export default injectsheet(styles)(Banner);